/* dev-brands-marquee.js */

(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.brands-marquee');
    sections.forEach(section => init(section));
  });

  function init(section) {
    const track = section.querySelector('[data-marquee-track]');
    if (!track) return;

    const slides = track.querySelectorAll('[data-marquee-slide]');
    if (slides.length < 2) return;

    /* Clone all slides and append to track for seamless infinite loop */
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }
})();
